export const medication_request_status = {
    active: { text: 'Activo', color: 'green' },
    'on-hold': { text: 'Suspendido', color: 'orange' },
    ended: { text: 'Terminado', color: 'blue' },
    stopped: { text: 'Detenido', color: 'red' },
    completed: { text: 'Completado', color: 'blue' },
    cancelled: { text: 'Cancelado', color: 'red' },
    'entered-in-error': { text: 'Errata', color: 'grey' },
    draft: { text: 'Borrador', color: 'grey' },
    unknown: { text: 'Desconocido', color: 'grey' },
    refill: { text: 'Activo', color: 'green' },
    'first-fill': { text: 'Activo', color: 'green' },
};
